import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAN9XoItDmTx5fZb5Btt13t2KF9N5mdTO4",
  authDomain: "sit-chess-club.firebaseapp.com",
  projectId: "sit-chess-club",
  storageBucket: "sit-chess-club.firebasestorage.app",
  messagingSenderId: "270999305134",
  appId: "1:270999305134:web:b5082519dcb0aa85ab263f",
  measurementId: "G-K65Q4D9YMJ",
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Helper function to log events
export const logAnalyticsEvent = (eventName, eventParams = {}) => {
  if (analytics) {
    logEvent(analytics, eventName, eventParams);
  }
};

export { analytics };
export default app;
